__turbopack_context__.v({
  "buttons": "footer-module__hs_M5q__buttons",
  "footer": "footer-module__hs_M5q__footer",
  "hidden": "footer-module__hs_M5q__hidden",
  "itemCount": "footer-module__hs_M5q__itemCount",
});
